import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/icons/exclamation.svg'


const _hoisted_1 = {
  key: 0,
  id: "container"
}
const _hoisted_2 = { id: "system-names" }
const _hoisted_3 = { id: "system-name-links" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "system-name-text" }
const _hoisted_6 = {
  key: 0,
  class: "system-name-icon mr-4"
}
const _hoisted_7 = { id: "system-info" }
const _hoisted_8 = {
  key: 0,
  class: "ml-4"
}
const _hoisted_9 = { class: "ds-section-title-huge" }
const _hoisted_10 = { class: "staticTable text-medium" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_ctx.versionGuardAllowed && _ctx.loadedLayoutRevisions)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "ds-section-title-medium section-title-dark pl-4" }, "System names", -1)),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layoutRevisions, (layoutRevision, index) => {
              return (_openBlock(), _createElementBlock("div", {
                onClick: ($event: any) => (_ctx.selectSystem(index)),
                class: _normalizeClass([{'mode-links-selected': index === _ctx.selectedSystemIndex}, "mode-links system-name-container"]),
                key: index + '-key'
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["pl-4", {'notification-text': _ctx.layoutRevisionMismatch(index)}])
                  }, _toDisplayString(layoutRevision.name), 3)
                ]),
                (_ctx.layoutRevisionMismatch(index))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[0] || (_cache[0] = [
                      _createElementVNode("div", { class: "exclamation-icon" }, [
                        _createElementVNode("img", { src: _imports_0 })
                      ], -1)
                    ])))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_4))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.selectedSystemIndex !== undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.layoutRevisions[_ctx.selectedSystemIndex].name), 1),
                _cache[12] || (_cache[12] = _createElementVNode("hr", null, null, -1)),
                _cache[13] || (_cache[13] = _createElementVNode("p", { class: "ds-section-title-medium" }, "Layout revisions", -1)),
                _createElementVNode("table", _hoisted_10, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[2] || (_cache[2] = _createElementVNode("th", null, " Source ", -1)),
                      _createElementVNode("th", {
                        class: _normalizeClass({'notification-text': _ctx.layoutRevisionMismatch(_ctx.selectedSystemIndex)})
                      }, " Revision ", 2),
                      _cache[3] || (_cache[3] = _createElementVNode("th", null, " Date ", -1)),
                      _cache[4] || (_cache[4] = _createElementVNode("th", null, " Time ", -1)),
                      _cache[5] || (_cache[5] = _createElementVNode("th", null, " User ", -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[6] || (_cache[6] = _createElementVNode("td", null, "License", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass({'notification-text': _ctx.layoutRevisionMismatch(_ctx.selectedSystemIndex)})
                      }, _toDisplayString(_ctx.licenseLayoutRevision), 3),
                      _createElementVNode("td", null, _toDisplayString(_ctx.licenseCreationDate), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.licenseCreationTime), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.licenseEmail), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[7] || (_cache[7] = _createElementVNode("td", null, "FleetController", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass({'notification-text': _ctx.layoutRevisionMismatch(_ctx.selectedSystemIndex)})
                      }, _toDisplayString(_ctx.systemLayoutRevision), 3),
                      _cache[8] || (_cache[8] = _createElementVNode("td", null, "N/A", -1)),
                      _cache[9] || (_cache[9] = _createElementVNode("td", null, "N/A", -1)),
                      _cache[10] || (_cache[10] = _createElementVNode("td", null, "N/A", -1))
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agvs, (agv, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: agv.agvId + index
                      }, [
                        _createElementVNode("td", null, _toDisplayString('AGV' + agv.agvId), 1),
                        _createElementVNode("td", {
                          class: _normalizeClass({'notification-text': _ctx.layoutRevisionMismatch(_ctx.selectedSystemIndex)})
                        }, _toDisplayString(agv.layoutRevision), 3),
                        _createElementVNode("td", null, _toDisplayString(_ctx.parseDate(agv.layoutModificationTime)), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.parseTime(agv.layoutModificationTime)), 1),
                        _cache[11] || (_cache[11] = _createElementVNode("td", null, "N/A", -1))
                      ]))
                    }), 128))
                  ])
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("hr", null, null, -1))
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_ctx.versionGuardAllowed && _ctx.loadingLayoutRevisions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_el_icon, {
            class: "is-loading",
            style: {"font-size":"100px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_loading)
            ]),
            _: 1
          })
        ]))
      : (_ctx.versionGuardAllowed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[15] || (_cache[15] = [
            _createElementVNode("p", { class: "ml-2" }, "There was a problem loading layout revisions. Please try again later.", -1)
          ])))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[16] || (_cache[16] = [
            _createElementVNode("p", { class: "ml-2" }, "You do not have access rights to version guard feature.", -1)
          ])))
}